import { render } from "./Exports.vue?vue&type=template&id=1a0cddbf"
import script from "./Exports.vue?vue&type=script&lang=js"
export * from "./Exports.vue?vue&type=script&lang=js"

import "./Exports.vue?vue&type=style&index=0&id=1a0cddbf&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Exports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a0cddbf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a0cddbf', __exports__)) {
    console.log('reload')
    api.reload('1a0cddbf', __exports__)
  }
  
  module.hot.accept("./Exports.vue?vue&type=template&id=1a0cddbf", () => {
    console.log('re-render')
    api.rerender('1a0cddbf', render)
  })

}


export default __exports__